import { makeAutoObservable, runInAction } from "mobx";
import { ErrorBox } from "./ErrorBox";
export class TextFieldControler {
    constructor(params) {
        var _a, _b;
        this._value = (_a = params.initialValue) !== null && _a !== void 0 ? _a : "";
        this._touched = false;
        this.update = params.update;
        this.errorBox = (_b = params.errorBox) !== null && _b !== void 0 ? _b : new ErrorBox({ errorMessages: {} });
        makeAutoObservable(this);
    }
    onChange(value) {
        this._value = value;
        runInAction(() => this.update(value));
    }
    onBlur() {
        this.touch();
    }
    touch() {
        this._touched = true;
    }
    get value() {
        return this._value;
    }
    get touched() {
        return this._touched;
    }
    get props() {
        return {
            value: this.value,
            onChange: this.onChange.bind(this),
            onBlur: this.onBlur.bind(this),
        };
    }
    get errors() {
        return this.errorBox.errors;
    }
    get invalid() {
        return this.errors.length > 0;
    }
}
